import NotFund from "../views/error/NotFund";
import Admin from "../views/admin/Index";

//需要登录
const requireLoginMeta = { requireLogin: true };

//需要访问权限
const requireAuthMeta = { requireAuth: true };

//路由表
const routes = [
	{
		path: "/",
		name: "Login",
		component: () => import(/* webpackChunkName: "login" */ "../views/login/Login.vue"),
	},
    {
        path: "/login2",
        name: "Login2",
        component: () => import(/* webpackChunkName: "login" */ "../views/login/Login2.vue"),
    },
	{
		path: "/login",
		name: "Login",
		component: () => import(/* webpackChunkName: "login" */ "../views/login/Login.vue"),
	},
	{
		path: "/admin",
		name: "admin",
		component: Admin,
		meta: { ...requireLoginMeta, ...requireAuthMeta },
		children: [
			{
				path: "home",
				name: "Home",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import(/* webpackChunkName: "home" */ "../views/admin/Home.vue"),
			},
			{
				path: "resources",
				name: "resources",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import(/* webpackChunkName: "resouces" */ "../views/resources/Index.vue"),
			},
			{
				path: "menu",
				name: "menu",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import(/* webpackChunkName: "menu" */ "../views/menu/Index.vue"),
			},
			{
				path: "permission",
				name: "permission",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import(/* webpackChunkName: "permission" */ "../views/permission/Index.vue"),
			},
			{
				path: "mini_permission",
				name: "mini_permission",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import(/* webpackChunkName: "mini_permission" */ "../views/permission/MiniIndex.vue"),
			},
			{
				path: "user",
				name: "user",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import(/* webpackChunkName: "mini_permission" */ "../views/user/Index.vue"),
			},
			{
				path: "applet",
				name: "applet",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import(/* webpackChunkName: "mini_permission" */ "../views/applet/Index.vue"),
			},
			{
				path: "place",
				name: "place",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import(/* webpackChunkName: "mini_permission" */ "../views/place/Index.vue"),
			},
			{
				path: "placeIndex",
				name: "placeIndex",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import(/* webpackChunkName: "mini_permission" */ "../views/place/Index1.vue"),
			},
			// 出租房规格管理
			{
				path: "rental_examine",
				name: "rental_examine",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/rental/examine.vue"),
			},
			{
				path: "hidden_danger",
				name: "hidden_danger",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/hidden_danger/Index.vue"),
			},
			//其他配置---行业
			{
				path: "config_industry",
				name: "config_industry",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/config_industry/Index.vue"),
			},
			//其他配置---场所状态
			{
				path: "config_site_status",
				name: "config_site_status",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/config_site_status/Index.vue"),
			},
			//隐患描述
			{
				path: "hidden_danger_analysis",
				name: "hidden_danger_analysis",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/hidden_danger_analysis/Index.vue"),
			},
			//检查规范
			{
				path: "hidden_danger_check",
				name: "hidden_danger_check",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/hidden_danger_check/Index.vue"),
			},
			//数据统计
			{
				path: "statistics",
				name: "statistics",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/statistics/Index.vue"),
			},
			//隐患追踪
			{
				path: "hidden_danger_tracking",
				name: "hidden_danger_tracking",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/hidden_danger_tracking/Index.vue"),
			},
			//设备安装统计
			{
				path: "equipment_count",
				name: "equipment_count",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/equipment_count/Index.vue"),
			},
			//设备安装管理
			{
				path: "equipment_manage",
				name: "equipment_manage",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/equipment_manage/Index.vue"),
			},
			//出租屋档案
			{
				path: "rental_file",
				name: "rental_file",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/rental_file/Index.vue"),
			},
			//社区部门管理
			{
				path: "config_department",
				name: "config_department",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/config_department/Index.vue"),
			},
			//器材管理
			{
				path: "equipment",
				name: "equipment",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/equipment/Index.vue"),
			},

			//器材管理
			{
				path: "logs",
				name: "logs",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/logs/Index.vue"),
			},
			//场所类型管理
			{
				path: "place_type",
				name: "place_type",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/place_type/Index.vue"),
			},

			//测试管理
			{
				path: "test",
				name: "test",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/applet/Test.vue"),
			},
			//三小管理
			{
				path: "sx_examine",
				name: "sx_examine",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/check_sx/examine.vue"),
			},
			//三小档案
			{
				path: "sx_file",
				name: "sx_file",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/check_sx_file/Index.vue"),
			},
			//公共场所管理
			{
				path: "gg_examine",
				name: "gg_examine",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/check_gg/examine.vue"),
			},
			//公共场所档案
			{
				path: "gg_file",
				name: "gg_file",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/check_gg_file/Index.vue"),
			},
			//工业企业场所管理
			{
				path: "gyqy_examine",
				name: "gyqy_examine",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/check_gyqy/examine.vue"),
			},
			//工业企业档案
			{
				path: "gyqy_file",
				name: "gyqy_file",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/check_gyqy_file/Index.vue"),
			},
			//大型商业综合体
			{
				path: "zht_examine",
				name: "zht_examine",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/check_zht/examine.vue"),
			},
			//大型商业综合体档案
			{
				path: "zht_file",
				name: "zht_file",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/check_zht_file/Index.vue"),
			},
			//老旧住宅小区
			{
				path: "zz_examine",
				name: "zz_examine",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/check_zz/examine.vue"),
			},
			//老旧住宅小区档案
			{
				path: "zz_file",
				name: "zz_file",
				meta: { ...requireLoginMeta, ...requireAuthMeta },
				component: () => import("../views/check_zz_file/Index.vue"),
			},
			//地图
			

		],
	},
	{
		path: "/map",
		name: "map",
		// meta: { ...requireLoginMeta, ...requireAuthMeta },
		component: () => import("../views/map/Index.vue"),
	},
	{
		path: "*",
		name: "NotFund",
		component: NotFund,
	},
];

export default routes;
